import { TabKeys } from 'containers/SubSidebar/AiLibContent/consts'
import { IAiLibState } from 'store/types/aiLib'

export const getInitialState = (): IAiLibState => ({
  activeTab: TabKeys.VIDEOS,
  isFiltersOpen: false,
  filters: {
    modelCode: null,
    duration: null,
    aspectRatio: null,
    quality: null,
    isHistoryScopedToCurrentProject: false
  },
  isLoaded: false,
  isInitialLoading: false,
  isLoadingMore: false,
  historyList: [],
  historyTotalCount: 0,
  allModels: [],
  isAllModelsLoading: false
})
